<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <v-row>
                        <v-col cols="12" sm="7" md="7" class="pb-n5" v-if="!this.formData.lockstaff">
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupepfve.epfve')"
                                type="text"
                                dense
                                v-model="formData.epfveid"
                                :items="epfveGroupList"
                                @change="changeEpfveGroupHandler(formData.epfveid)"
                            ></v-autocomplete>
                        </v-col>

                         <v-col cols="12" sm="7" md="7" class="pb-n5" v-else>
                            <v-autocomplete
                                outlined
                                :label="this.$t('setupepfve.epfve')"
                                type="text"
                                dense
                                v-model="formData.epfveid"
                                :items="epfveGroupList"
                                readonly
                                background-color="#ffeab2"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="1" sm="1" class="pb-n5">
                            <v-dialog v-model="epfvegroupDialog" max-width="500px" persistent>
                                <template v-slot:activator="{ on }">
                                    <v-btn dense v-on="on">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <app-genericform 
                                        v-bind:parentData = "{
                                            tabItems: epfveGroupItems,
                                            formTitle: `${this.$t('setupepfve.epfvesetup')}`,
                                            formId: 'epfvegroupsetup'
                                        }"

                                        v-on:input="itemData = $event"
                                        v-on:saveEpfveGroup="saveEpfveGroupHandler"
                                        v-on:deleteEpfveGroup="deleteEpfveGroupHandler"
                                    />

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="warning"
                                            text
                                            @click="epfvegroupDialog = false"
                                        >
                                            {{$t('button.close')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                background-color="#ffeab2"
                                readonly
                                :label="this.$t('columns.description')"
                                type="text"
                                :rules="[rules.required]"
                                v-model="formData.epfvedesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.effectivefrom')"
                                type="date"
                                ref="startdate"
                                :rules="[rules.required]"
                                v-model="formData.startdate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.effectiveuntil')"
                                type="date"
                                ref="enddate"
                                :rules="[rules.required]"
                                v-model="formData.enddate"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-textarea
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                v-model="formData.remark"
                                @input="updateValue"
                                dense
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <app-table 
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.formData.epfvedetails
                            }"

                            v-on:input="addItemHandler"
                        />

                    </v-row>

                </v-container>

                <div v-if="isErr">
                    <app-error
                        v-bind:parentError="{
                            data: this.errMsg,
                            isErr: this.isErr
                        }"
                        v-on:closeError="isErr = $event"
                    />
                </div>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" />

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import GenericForm from '../../generic/GridForm';
import ErrorDialog from "../../common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
        'app-genericform': GenericForm,
        'app-error': ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                epfveid: this.parentObject.data.epfveid,
                epfvecode: this.parentObject.data.epfvecode,
                epfvedesc: this.parentObject.data.epfvedesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                remark: this.parentObject.data.remark,
                epfvedetails: this.parentObject.data.epfvedetails,
                lockstaff: this.parentObject.data.lockstaff,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },

            tabHeader: [
                { text: this.$t('columns.actions'),           value: 'action',        width: '100px', sortable: false},
                { text: this.$t('columns.company'),        value: 'compnyname',    width: '150px', sortable: true},
                { text: this.$t('columns.employmenttype'),    value: 'emptype',   width: '120px', sortable: true},
                { text: this.$t('reporalertlisting.age'),              value: 'age',           width: '100px', sortable: true},
                { text: this.$t('columns.gender'),           value: 'gendername',    width: '120px', sortable: true},
                { text: this.$t('columns.grade'),            value: 'grddesc',       width: '150px', sortable: true},
                { text: this.$t('setupepf.serviceperiod'),   value: 'servprd',       width: '120px', sortable: true},
                { text: this.$t('setupepf.wages'),            value: 'wages',         width: '100px', sortable: true},
                { text: this.$t('setupepf.eepercentage'),           value: 'eeamt',         width: '90px', sortable: true},
                { text: this.$t('setupepf.erpercentage'),           value: 'eramt',         width: '90px', sortable: true},
            ],

            selected: [],
            affectItems: [],
            epfveGroupItems: [],
            epfveGroupList: [],
            epfveGroup: [],

            errMsg: '',

            epfvegroupDialog: false,
            isErr: false,
            isEdit: this.parentObject.isEdit,
             search: this.parentObject.searchnew
        }
    },

    methods: {

        loadEpfveGroupListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/epfve/all'})
                .then(res => {
                    vm.epfveGroup = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.epfveGroupList.push(
                            {
                                text: res.data.rec[i].epfvecode,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.epfveGroupItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].epfvecode,
                                desc: res.data.rec[i].epfvedesc,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },
        
        addItemHandler($event) {
            this.formData.epfvedetails=$event

            this.updateValue();
        },

        updateValue() {
            this.$emit('input', {
                epfveid: this.formData.epfveid,
                epfvecode: this.formData.epfvecode,
                epfvedesc: this.formData.epfvedesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                remark: this.formData.remark,
                epfvedetails: this.formData.epfvedetails,
                lockstaff: this.formData.lockstaff,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        saveEpfveGroupHandler() {
            const vm = this;

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {
                    url: '/epfve/' + this.itemData.itemid, 
                    payload: {
                        epfvecode: this.itemData.itemcode,
                        epfvedesc: this.itemData.itemdesc,
                        stamp: this.itemData.itemstamp,
                        userid: this.formData.userid
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.epfveGroup = [];
                        vm.epfveGroupItems = [];
                        vm.epfveGroupList = [];

                        this.loadEpfveGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {
                    url: '/epfve/create', 
                    payload: {
                        epfvecode: this.itemData.itemcode,
                        epfvedesc: this.itemData.itemdesc,
                        userid: this.formData.userid
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.epfveGroup = [];
                        vm.epfveGroupItems = [];
                        vm.epfveGroupList = [];

                        this.loadEpfveGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteEpfveGroupHandler($event) {
            const vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {
                    url: '/epfve/' + $event.id + '/' + this.formData.userid})
                .then(res => {
                    if (res.data.status == 200) {
                        // resets all arrays
                        vm.epfveGroup = [];
                        vm.epfveGroupItems = [];
                        vm.epfveGroupList = [];

                        this.loadEpfveGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });                
            }

        },

        changeEpfveGroupHandler(id) {
            let item = this.epfveGroup.find(item => item.id === parseInt(id));
            
            this.formData.epfvecode = item.epfvecode;
            this.formData.epfvedesc = item.epfvedesc;
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'epfvelist', params: { search: this.search}});
        },

        closeHandler() {
            this.subDialog = false;
            this.isErr = !this.isErr;
            this.errMsg = '';
        }
    },

    mounted() {
        this.loadEpfveGroupListHandler();
        if (this.parentObject.isEdit){
            this.duplicateStaffData = this.formData;
            
            if (this.parentObject.data.lockstaff == "N") {
                this.formData.lockstaff = false;
            } else {
                this.formData.lockstaff = true;
            }
        }
    }
}
</script>